//@flow
import React from 'react';
import {connectionModeImage} from '../../constants/ConnectionMode';
import {FormattedMessage} from 'react-intl';
import './ConnectionModeItem.less';


export const ConnectionModeItem = (props) => {

   const {mode, onSelect} = props;
   const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onSelect();
   };

   return (
      <button onClick={handleClick} className={'connection-mode-item'}>
         <div className="connection-mode-item__container">
            <div className={'connection-mode-item__container__image'}>
               <img
                  src={connectionModeImage[mode].src}
                  srcSet={connectionModeImage[mode].srcSet}
                  alt={mode}
               />
               <div className={'connection-mode-item__container__overlay'} />
            </div>
            <div className="align-item_flex_IE" >
               <div className={'connection-mode-item__container__subtitle'}>
                  <div className="connection-mode-item__container__subtitle__text">
                     <FormattedMessage
                        id={'connection-mode.' + mode}
                        tagName="h1"
                     />
                  </div>
               </div>
            </div>
         </div>
      </button>
   );
};
